import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { SlidersTable } from "../../UI/Sliders/SlidersTable";

const Sliders = () => {
  return (
    <div>
      <PanelHead title="Sliders" />
      <PanelBody content={<SlidersTable />} />
    </div>
  );
};

export default Sliders;
